import { Button, IconButton, Tooltip } from "@kaltura/ds-react-components";
import React from "react";
import { Subscribe24Icon, Subscribed24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";

export type SubscribeButtonProps = {
    subscribed: boolean;
    onToggle: () => void;
    processing: boolean;
    buttonColor: "primary" | "secondary" | "translucent";
    useIconButton: boolean;
    isBorderless?: boolean;
};

/**
 *  channel subscribe button
 */
const SubscribeButton = (props: SubscribeButtonProps) => {
    const { subscribed, onToggle, processing, buttonColor, useIconButton, isBorderless } = props;

    const buttonText = subscribed ? translate("Unsubscribe") : translate("Subscribe");

    const toolTipText = subscribed ? translate("Click to unsubscribe") : translate("Click to subscribe");

    return (
        <>
            {useIconButton && (
                <Tooltip title={toolTipText} placement="top">
                    <IconButton
                        className={`kms-ds-channel-header-subscribe`}
                        color={buttonColor}
                        variant="pill"
                        onClick={onToggle}
                        loading={processing}
                    >
                        {subscribed && <Subscribed24Icon />}
                        {!subscribed && <Subscribe24Icon />}
                    </IconButton>
                </Tooltip>
            )}
            {!useIconButton && (
                <Tooltip title={toolTipText} placement="top">
                    <Button
                        className={`kms-ds-channel-header-subscribe`}
                        onClick={onToggle}
                        startIcon={subscribed ? <Subscribed24Icon /> : <Subscribe24Icon />}
                        color={buttonColor}
                        loading={processing}
                        variant={isBorderless ? "borderless" : "pill"}
                    >
                        {buttonText}
                    </Button>
                </Tooltip>
            )}
        </>
    );
};

export default SubscribeButton;
